export const modules = {
	CLAIM_GIFTS: "claim-gifts",
	COMPLETED_GIFTS: "completed-gifts",
	RESTAURANT_COMPLETED_GIFTS: "restaurantCompletedGifts",
	EMAIL_TEMPLATE: "emailTemplate",
	GIFTS: "gifts",
	GIFTS_ORDERS: "giftOrders",
	ORDERS: "orders",
	PAYOUTS: "payouts",
	PROMOTIONS: "promotions",
	REFERRED_USERS: "referredUsers",
	RESTAURANTS: "restaurants",
	RESTAURANTS_CHILD: "restaurantsChild",
	TRANSACTIONS: "transactions",
	USERS: "users",
	PENDING_USERS: "pendingUsers",
	GUEST_USERS: "guestUser",
	REFERRALS: "referrals",
	contentReports: "contentReports",
	UNCLAIMED_GIFTS: "unClaimedGifts",
	PROMO_GIFTS: "promoGifts",
	PROMO_APPROVAL_REQUESTS: "promoApprovalRequests",
};
